var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classes},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"vi-help-features--text"},[_c('p',[_vm._v(_vm._s(_vm.data && _vm.data.dataDetail || '暂无')+" ")])]),_vm._v(" "),_c('div',{staticClass:"vi-help--item__more",on:{"click":_vm.onToPath}},[_c('a',{attrs:{"href":"javascript:"}},[_vm._v("了解更多")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vi-help--item__title"},[_c('b',[_vm._v("功能介绍")])])
}]

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/js/module/layout/_source/helpFeatures.vue